import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import ChooseOrganizationMenu from "./ChooseOrganizationMenu";
import {PortalUrl} from "../utils/portal-urls";
import {Divider, ListItem, ListItemIcon, ListItemText, ListSubheader} from "@mui/material";
import {deepOrange, deepPurple} from "@mui/material/colors";
import Badge from "@mui/material/Badge";
import BusinessIcon from '@mui/icons-material/Business';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EmailIcon from '@mui/icons-material/Email';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { makeStyles, withStyles } from '@mui/styles';
import {Article, Home, People, Receipt} from "@mui/icons-material";
import RuleIcon from '@mui/icons-material/Rule';
import SourceIcon from '@mui/icons-material/Source';
import BackupIcon from '@mui/icons-material/Backup';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    purple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],
    },
    moduleTitle: {
        // paddingLeft: '30px',
        marginTop: '15px',
        fontWeight: 'bold',
        color: '#3C78B9dd',
        textTransform: 'uppercase'
    }
}));

const MenuItemBadge = withStyles((theme) => ({
    badge: {
        right: -6,
        top: 0,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}))(Badge);

function HomeIcon() {
    return <Home />;
}

function PeopleIcon() {
    return <People />;
}

function ReceiptIcon() {
    return <Receipt />;
}

export default function UserMenuList(props){
    const path = props.path;
    const signOut = props.signOut;
    // const {user} = props.account;
    const account = props.account;
    const user = account.user || {};
    const messageFolders = account.messageFolders || [];

    // remove this will cause the <ListItem selected> highlight delay
    const location = useLocation();

    const unviewedIncomingAdtCount = user && user.unviewedIncomingAdtCount || 0;
    const unviewedIncomingPatientCount = user && user.unviewedIncomingPatientCount || 0;
    const unviewedIncomingVisitCount = user && user.unviewedIncomingVisitCount || 0;
    const unviewedOutgoingAdtCount = user && user.unviewedOutgoingAdtCount || 0;
    const isMasterAdmin = account.user.userType === "masterAdmin";
    const isAdmin = account.user.userType === "admin";
    const classes = useStyles();
    // const dashboardLink = <Link to={"/Patient/e4b2dbce-0621-4229-a9ad-fcf88c247ce2/"}  />;

    var homeActive = false;
    var usersActive = false;
    let externalSourceActive = false;
    let validationRules = false;
    let published = false;
    let contributions = false;
    let hisps = false;
    var ReportsActive = false;
    var notificationVisitActive = false, notificationAdtActive = false, notificationPatientActive = false, messageActive = false, referralActive = false;
    var outboundNotificationPatientActive = false, notificationProviderActive = false, subscriptionActive = false;
    var auditLogs = false;

    if (window.location.pathname.startsWith(PortalUrl.NotificationVisitBase)){
        notificationVisitActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.NotificationAdtBase)){
        notificationAdtActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.NotificationPatientBase)){
        notificationPatientActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.NotificationOutboundAdtHome)){
        outboundNotificationPatientActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.NotificationProvider.base)){
        notificationProviderActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Message)){
        messageActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.ReferralHome)){
        referralActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Subscription.base)){
        subscriptionActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.AuditLogs.base)){
        auditLogs = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Users.base)) {
        usersActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.ExternalSource.base)) {
        externalSourceActive = true;
    } else if (window.location.pathname.startsWith(PortalUrl.ValidationRules.base)) {
        validationRules = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Contributions.base)) {
        contributions = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Published.base)) {
        published = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Published.HocReport.base)) {
        published = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Contributions.HocReport.base)) {
        contributions = true;
    } else if (window.location.pathname.startsWith(PortalUrl.Hisps.base)) {
        hisps = true;
    } else {
        homeActive = true;
    }

    var sendNotificationModule = account && account.organization && account.organization.sendNotificationModule;
    var notificationModule = account && account.organization && account.organization.notificationModule;
    var referralModule = account && account.organization && account.organization.referralModule;
    var messageModule = account && account.organization && account.organization.messageModule;

    return <div >

        <ListItem button component={Link} to={`/`}  selected={homeActive} >
            <ListItemIcon>
                <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" secondary='Home Dashboard' />
        </ListItem>
        <ListItem button component={Link} to={PortalUrl.Users.Home.pattern} selected={usersActive}>
            <ListItemIcon>
                <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary="Users" secondary="Manage admin/api accounts" />
        </ListItem>
        <ListItem button component={Link} to={PortalUrl.Hisps.Home.pattern} selected={hisps}>
            <ListItemIcon>
                <CorporateFareIcon />
            </ListItemIcon>
            <ListItemText primary="HISPs" secondary="Manage HISPs" />
        </ListItem>
        <ListItem button component={Link} to={PortalUrl.ExternalSource.Home.pattern} selected={externalSourceActive}>
            <ListItemIcon>
                <CloudDoneIcon />
            </ListItemIcon>
            <ListItemText primary="External Sources" secondary={"Manage NPI / ValueSets"} />
        </ListItem>

        {/*<ListItem button component={Link} to={PortalUrl.ExternalSourceManagement.Npi.pattern_home} selected={pageActive}>*/}
        {/*    <ListItemIcon>*/}
        {/*        <Article/>*/}
        {/*    </ListItemIcon>*/}
        {/*    <ListItemText primary="Page" />*/}
        {/*</ListItem>*/}
        <ListItem button component={Link} to={PortalUrl.ValidationRules.Home.pattern} selected={validationRules}>
            <ListItemIcon>
                <RuleIcon />
            </ListItemIcon>
            <ListItemText primary="Validation Rules" secondary="Manage validation rules" />
        </ListItem>
        <ListItem button component={Link} to={PortalUrl.Published.Home.pattern} selected={published}>
            <ListItemIcon>
                <SummarizeIcon />
            </ListItemIcon>
            <ListItemText primary="Publications" secondary="View publications, reports" />
        </ListItem>
        <ListItem button component={Link} to={PortalUrl.Contributions.Home.pattern} selected={contributions}>
            <ListItemIcon>
                <FileUploadIcon />
            </ListItemIcon>
            <ListItemText primary="Contributions" secondary="View contributions, reports" />
        </ListItem>
        <ListItem button component={Link} to={PortalUrl.AuditLogs.Home.pattern} selected={auditLogs}>
            <ListItemIcon>
                <ReceiptIcon />
            </ListItemIcon>
            <ListItemText primary="Audit Logs" secondary="View audit logs" />
        </ListItem>
        {/*<ListItem button component={Link} to={PortalUrl.Users.Home.pattern} selected={LogsActive}>*/}
        {/*    <ListItemIcon>*/}
        {/*        <ReceiptIcon />*/}
        {/*    </ListItemIcon>*/}
        {/*    <ListItemText primary="Reports (TODO)" />*/}
        {/*</ListItem>*/}

        {/*{isMasterAdmin &&*/}
        {/*<ListItem button component={Link} to={PortalUrl.Organization.Home.pattern} selected={LogsActive} >*/}
        {/*    <ListItemIcon>*/}
        {/*        <BusinessIcon />*/}
        {/*    </ListItemIcon>*/}
        {/*    <ListItemText primary="Organizations" />*/}
        {/*</ListItem>}*/}

        {notificationModule && <div>
            <Divider/>
            <ListSubheader className={classes.moduleTitle} inset> Inbound Notification </ListSubheader>


            <ListItem button component={Link} to={PortalUrl.NotificationVisitHome} selected={notificationVisitActive} >
                <ListItemIcon>
                    <ApartmentIcon />
                </ListItemIcon>
                {unviewedIncomingVisitCount > 0 && <ListItemText primary={<MenuItemBadge badgeContent={unviewedIncomingVisitCount} color='secondary' children='Visits' />} secondary="by last update time" /> }
                {unviewedIncomingVisitCount === 0 && <ListItemText primary="Visits" secondary="by last update time" /> }
            </ListItem>

            <ListItem button component={Link} to={PortalUrl.NotificationAdtHome} selected={notificationAdtActive} >
                <ListItemIcon>
                    <strong>ADT</strong>
                </ListItemIcon>
                {unviewedIncomingAdtCount > 0 && <ListItemText primary={<MenuItemBadge badgeContent={unviewedIncomingAdtCount} color='secondary' children='ADT Notifications' />} secondary="by creation time" /> }
                {unviewedIncomingAdtCount === 0 && <ListItemText primary="ADT Notifications"  secondary="by creation time" /> }
            </ListItem>

            <ListItem button component={Link} to={PortalUrl.NotificationPatientHome} selected={notificationPatientActive} >
                <ListItemIcon>
                    <PeopleIcon />
                </ListItemIcon>
                {unviewedIncomingPatientCount > 0 && <ListItemText primary={<MenuItemBadge badgeContent={unviewedIncomingPatientCount} color='secondary' children='Patients' />} secondary="by Episode of Care status" /> }
                {unviewedIncomingPatientCount === 0 && <ListItemText primary="Patients"  secondary="by Episode of Care status" /> }
            </ListItem>

        </div>}

        {sendNotificationModule && <div>
            <Divider/>
            <ListSubheader className={classes.moduleTitle} inset> Outbound Notification </ListSubheader>
            <ListItem button component={Link} to={PortalUrl.NotificationOutboundAdtHome} selected={outboundNotificationPatientActive} >
                <ListItemIcon>
                    <strong>ADT</strong>
                </ListItemIcon>
                {unviewedOutgoingAdtCount > 0 && <ListItemText primary={<MenuItemBadge badgeContent={unviewedOutgoingAdtCount} color='secondary' children='Outgoing ADT Messages'  />} secondary="by creation time" /> }
                {unviewedOutgoingAdtCount === 0 && <ListItemText primary="Outgoing ADT Messages" secondary="by creation time" /> }
            </ListItem>
            <ListItem button component={Link} to={PortalUrl.NotificationProvider.home} selected={notificationProviderActive} >
                <ListItemIcon>
                    <ContactMailIcon />
                </ListItemIcon>
                <ListItemText primary="Receiver Providers" secondary="by creation time" />
            </ListItem>
            <ListItem button component={Link} to={PortalUrl.Subscription.Home.pattern} selected={subscriptionActive} >
                <ListItemIcon>
                    <NotificationsActiveIcon />
                </ListItemIcon>
                <ListItemText primary="Subscriptions" secondary="by subscriber" />
            </ListItem>
        </div>}

        {/*{referralModule && <div>*/}
        {/*    <Divider/>*/}
        {/*    <ListSubheader className={classes.moduleTitle} inset> Referral </ListSubheader>*/}

        {/*    <ListItem button component={Link} to={PortalUrl.ReferralHome} selected={referralActive} >*/}
        {/*        <ListItemIcon>*/}
        {/*            <EventNoteIcon />*/}
        {/*        </ListItemIcon>*/}
        {/*        <ListItemText primary="Referrals" />*/}
        {/*    </ListItem>*/}
        {/*</div>}*/}


        {messageModule && <div>
            <Divider/>
            <ListSubheader className={classes.moduleTitle} inset> Message </ListSubheader>

            { messageFolders.length > 0 && messageFolders.map( (m, index) =>
                <ListItem key={`menu-item-msg-folder-${index}`} button component={Link} to={PortalUrl.MessageFolder.getPath(m)} selected={messageActive} >
                <ListItemIcon>
                    <EmailIcon />
                </ListItemIcon>
                <ListItemText primary={m.directAddress} secondary={`${m.inbound? "Inbox" : "Sent"} ${m.shared && " - SHARED"}`} />
            </ListItem>)}
        </div>}


        <Divider />
        <br/>
        <br/>

        <ListItem button onClick={signOut} >
            <ListItemIcon>
                <ExitToAppIcon style={{ transform: "rotate(180deg)" }} />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
        </ListItem>
    </div>;
}
